<template>
  <div class="main" id="paperConfig">
    <div class="paperItem">
      <div class="title">
        全国通用入司考试
      </div>
      <div class="paperItemMain">
        <el-row class="row">
          <el-col :span="3"> 试题数量&nbsp;<el-input class="input" v-model="show.questionCount"></el-input> </el-col>
          <el-col :span="4" :offset="0"> 人寿险题目比例&nbsp;<el-input class="input" v-model="show.life"></el-input> </el-col>
        </el-row>
        <el-row class="row ">
          <el-col :span="2" :offset="3">
            题目系数&nbsp;
          </el-col>
          <el-col :span="3"> 简单题&nbsp;<el-input class="input" v-model="show.lifeLow" ></el-input> </el-col>
          <el-col :span="3"> 中等题&nbsp;<el-input class="input" v-model="show.lifeIntermediate" ></el-input> </el-col>
          <el-col :span="3"> 困难题&nbsp;<el-input class="input" v-model="show.lifeSenior" ></el-input> </el-col>
        </el-row>
        <el-row class="row ">
          <el-col>
            目前符合条件的题目共有（{{ initQuestionCount.lifeTotal }}）简单题（{{ initQuestionCount.lifeLowNum }}） 中等题（{{
              initQuestionCount.lifeIntermediateNum
            }}）困难题（{{ initQuestionCount.lifeSeniorNum }}）
          </el-col>
        </el-row>
        <div class="separate"></div>
        <el-row class="row">
          <el-col :span="3">
            &nbsp;
          </el-col>
          <el-col :span="4" :offset="0"> 财险题目比例&nbsp;<el-input class="input" v-model="show.finance" ></el-input> </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="2" :offset="3">
            题目系数&nbsp;
          </el-col>
          <el-col :span="3"> 简单题&nbsp;<el-input class="input" v-model="show.financeLow" ></el-input> </el-col>
          <el-col :span="3"> 中等题&nbsp;<el-input class="input" v-model="show.financeIntermediate" ></el-input> </el-col>
          <el-col :span="3"> 困难题&nbsp;<el-input class="input" v-model="show.financeSenior" ></el-input> </el-col>
        </el-row>
        <el-row class="row ">
          <el-col>
            目前符合条件的题目共有（{{ initQuestionCount.financeTotal }}）简单题（{{ initQuestionCount.financeLowNum }}） 中等题（{{
              initQuestionCount.financeIntermediateNum
            }}）困难题（{{ initQuestionCount.financeSeniorNum }}）
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="4" :offset="21">
            <el-button type="info" @click="submitNewPaper" plain>确定</el-button>
          </el-col>
        </el-row>
        <el-row class="row"> <b>温馨提示:</b> 全国通用入司考试仅支持财险类和人寿类别题目，地区试卷仅支持通用类题目。 </el-row>
      </div>
    </div>
    <div id="new" class="paperItem">
      <div class="title">新人险种试卷</div>
      <div class="areapaperItemMain" style="padding-bottom: 60px;">
        <el-row class="row">
          <el-col :span="7">
            试卷包含的险种&nbsp;
            <el-select  v-model="riskCode" placeholder="请选择">
            <el-option disabled label="全部" :value="riskCode">全部</el-option>
            <el-option disabled v-for="item in riskList" :key="item.riskCode" :label="item.riskName" :value="item.riskCode"> </el-option>
          </el-select>
          </el-col>
          <el-col :span="10"> 题目数量&nbsp;<el-input class="input" v-model="questionNumber"></el-input> </el-col>
          <el-col :span="7">
            <el-button type="info" @click="submitNewPerParper" plain>确定</el-button>
            <div style="position: absolute;right: 19px;top: 40px;">当前考试题目总数为:{{subjectNum}}</div>
          </el-col>
        </el-row>
      </div>
      <!-- <div class="areapaperItemMain" style="padding-bottom: 60px;" v-for="(item, index) in paperAreas.length" :key="index" v-cloak>
        <el-row class="row">
          <el-col :span="7">
            试卷包含的险种&nbsp;
             <el-select v-model="paperAreas[index].riskCode" placeholder="请选择">
              <el-option v-for="item in riskList" :key="item.riskCode" :label="item.riskName" :value="item.riskCode"> </el-option>
            </el-select>  -->
            <!-- <el-select v-model="paperAreas[index].manageCom" placeholder="请选择">
              <el-option v-for="ManageCom in ManageComOptions" :key="ManageCom.value" :label="ManageCom.label" :value="ManageCom.value"> </el-option>
            </el-select> -->
          <!-- </el-col>
          <el-col :span="10"> 题目数量&nbsp;<el-input class="input" v-model="paperAreas[index].questionCount"></el-input> </el-col> -->
          <!-- <el-col :span="10"> 题目数量&nbsp;<el-input class="input" v-model="paperAreas[index].questionCount"></el-input> </el-col> -->
          <!-- <el-col :span="7">
            <el-button type="info" @click="submitAreaPaper(index)" plain>确定</el-button>
            <div style="position: absolute;right: 19px;top: 40px;">当前考试题目总数为:200</div>
          </el-col>
        </el-row>
      </div> -->
    </div>
    <!-- 新增 -->
    <div class="paperItem">
      <div class="title">互联网宣传和销售资质考试试卷</div>
      <div class="areapaperItemMain" v-cloak style="padding: 30px 0 15px 25px;text-align:left">
        <el-row class="row">
          <el-col :span="10"> 题目数量&nbsp;<el-input class="input" v-model="internetPaper.currentNumber"></el-input> </el-col>
          <el-col :span="10">
            <el-button type="info" @click="submitInternetPaper()" plain>确定</el-button>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="10">试题库考试题总数为：{{ internetPaper.totalNumber }}</el-col>
          <el-col :span="14"></el-col>
        </el-row>
      </div>
    </div>
    <div class="paperItem">
      <div class="title">地区试卷<el-button class="add_btn" type="info" @click="addAreaPaper" plain>新增</el-button></div>
      <div class="areapaperItemMain" v-for="(item, index) in paperAreas.length" :key="index" v-cloak>
        <el-row class="row">
          <el-col :span="7">
            试卷地区&nbsp;
            <el-select v-model="paperAreas[index].manageCom" placeholder="请选择">
              <el-option v-for="ManageCom in ManageComOptions" :key="ManageCom.value" :label="ManageCom.label" :value="ManageCom.value"> </el-option>
            </el-select>
          </el-col>
          <el-col :span="10"> 题目数量&nbsp;<el-input class="input" v-model="paperAreas[index].questionCount"></el-input> </el-col>
          <el-col :span="3">
            <el-button type="info" @click="submitAreaPaper(index)" plain>确定</el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="info" @click="deleteAreaPaper(index)" plain>删除</el-button>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="9">
            &nbsp;
          </el-col>
          <el-col :span="8" style="text-align:left;">
            题目系数&nbsp;困难题
          </el-col>
          <el-col :span="4"> </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/modules/api.js'
import url from '@/modules/url.js'
export default {
  data() {
    return {
      riskList:[],
      riskCode:null,
      questionNumber:'',
      riskCollect:'',
      params:{
        riskRange:'',
        riskCount:'',
        paperType:'NEW_RISK'
      },
      subjectNum:'',
      show: {
        paperType: '',
        manageCom: '',
        questionCount: '0',
        finance: '0',
        financeLow: '0',
        financeIntermediate: '0',
        financeSenior: '0',
        life: '0',
        lifeLow: '0',
        lifeIntermediate: '0',
        lifeSenior: '0',
        riskCount:'',
        riskRange:'',
      },
      req: {
        riskCount:'',
        riskRange:'',
        paperType: 'NEW_RISK',
        manageCom: '',
        questionCount: '',
        finance: '0',
        financeLow: '0',
        financeInter:'',
        mediate:'',
        financeIntermediate: '0',
        financeSenior: '0',
        life: '0',
        lifeLow: '0',
        lifeIntermediate: '0',
        lifeSenior: '0'
      },
      ManageComOptions: null,
      riskRange:[{}],
      paperAreas: [{}],
      riskCOunt:[{}],
      initQuestionCount: '',
      errorMessage: '',
      tempPapers: [{}],
      internetPaper: {}
    }
  },
  methods: {
    checkSubmit() {
      let totalPercent = Number.parseFloat(this.show.finance) + Number.parseFloat(this.show.life)
      if (totalPercent !== 1) {
        console.log('比例系数错误')
        this.errorMessage = '比例系数错误'
        return false
      }
      let life = Number.parseFloat(this.show.lifeLow) + Number.parseFloat(this.show.lifeSenior) + Number.parseFloat(this.show.lifeIntermediate)
      let finance = Number.parseFloat(this.show.financeLow) + Number.parseFloat(this.show.financeSenior) + Number.parseFloat(this.show.financeIntermediate)
      if (this.show.life === 0 && life !== 0) {
        console.log('寿险比例系数错误')
        this.errorMessage = '寿险比例系数错误'
        return false
      }
      if (life !== 0 && life !== 1) {
        console.log('寿险比例系数错误')
        this.errorMessage = '寿险比例系数错误'
        return false
      }
      if (this.show.finance === 0 && finance !== 0) {
        console.log('财险比例系数错误')
        this.errorMessage = '财险比例系数错误'
        return false
      }
      if (finance !== 0 && finance !== 1) {
        console.log('财险比例系数错误')
        this.errorMessage = '财险比例系数错误'
        return false
      }
      let lifeNum = Number.parseFloat(this.show.questionCount) * Number.parseFloat(this.show.life)
      if (lifeNum > this.initQuestionCount.lifeTotal) {
        console.log('寿险题目不足！')
        this.errorMessage = '寿险题目不足！'
        return false
      } else {
        let lifeLowNum = Number.parseFloat(lifeNum) * Number.parseFloat(this.show.lifeLow)
        let lifeIntermediate = Number.parseFloat(lifeNum) * Number.parseFloat(this.show.lifeIntermediate)
        let lifeSenior = Number.parseFloat(lifeNum) * Number.parseFloat(this.show.lifeSenior)
        console.log(lifeLowNum + '----' + lifeIntermediate + '----' + lifeSenior)
        if (
          lifeLowNum > Number.parseFloat(this.initQuestionCount.lifeLowNum) ||
          lifeIntermediate > Number.parseFloat(this.initQuestionCount.lifeIntermediateNum) ||
          lifeSenior > Number.parseFloat(this.initQuestionCount.lifeSeniorNum)
        ) {
          console.log('题目与系数不符！')
          this.errorMessage = '题目与系数不符！'
          return false
        }
      }
      let financeNum = Number.parseFloat(this.show.questionCount) * Number.parseFloat(this.show.finance)
      if (financeNum > this.initQuestionCount.financeTotal) {
        console.log('寿险题目不足！')
        this.errorMessage = '寿险题目不足！'
        return false
      } else {
        let financeLowNum = Number.parseFloat(financeNum) * Number.parseFloat(this.show.financeLow)
        let financeIntermediateNum = Number.parseFloat(financeNum) * Number.parseFloat(this.show.financeIntermediate)
        let financeSeniorNum = Number.parseFloat(financeNum) * Number.parseFloat(this.show.financeSenior)
        if (
          financeLowNum > Number.parseFloat(this.initQuestionCount.financeLowNum) ||
          financeIntermediateNum > Number.parseFloat(this.initQuestionCount.financeIntermediateNum) ||
          financeSeniorNum > Number.parseFloat(this.initQuestionCount.financeSeniorNum)
        ) {
          console.log('题目与系数不符！')
          this.errorMessage = '题目与系数不符！'
          return false
        }
      }
      return true
    },
    submitInternetPaper() {
      if(this.internetPaper.currentNumber > this.internetPaper.totalNumber){
        this.$message.error('您输入的题目数量大于试题总数，请重新输入')
        return
      }
      let that = this
      api.post(url.saveInternetPaperType, {
        questionType: 'INTERNET',
        number: that.internetPaper.currentNumber
      }, function(res) {
        if (res.result.isSuccess === true) {
          that.$message({
            type: 'success',
            message: '成功'
          })
          that.internetPaper = res.data
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    //获取类型险种列表
    initRiskTypes(){
      let that = this
      api.post(url.initRiskTypes, {}, function(res) {
        if (res.result.isSuccess) {
          that.riskList = res.data
          that.riskRange = res.data
          let arr = []
          that.riskList.forEach((item,index)=>{
            if(arr.indexOf(item.riskCode) === -1) {
              arr.push(item.riskCode)
            }
          })
          that.riskCollect = arr.join(',')
          window.sessionStorage.setItem('riskCollect',that.riskCollect)
        } else {
          that.$message({

          });
        }
      });
    },
    //获取互联网考试数量
    initInternetPaper(){
      let that = this
      api.post(url.saveInternetPaperType, {questionType:'INTERNET'}, function(res) {
        if (res.result.isSuccess) {
          that.internetPaper = res.data
        }
      });
    },
    //提交保存新人险种试卷
    submitNewPerParper(){
      let that =this
        this.params.riskRange = this.riskCollect,
        this.params.riskCount = this.questionNumber,
      api.post(url.saveExamPaper, this.params, function(res) {
        if (res.result.isSuccess === true) {
          window.sessionStorage.setItem('questionNumber',that.params.riskCount)
          that.$message({
            type: 'success',
            message: '成功'
      })
        that.init()
        } else {
            if (res.result.errorCode == 'E002') {
              that.$message.error(res.result.errors[0].error)
            } else {
              that.$message.error(res.result.error)
            }
          }
      })
    },
    submitNewPaper() {
      let that = this
      if (this.checkSubmit()) {
        console.log('符合条件')
        this.req = this.show
        api.post(url.saveExamPaper, this.req, function(res) {
          if (res.result.isSuccess === true) {
            that.$message({
              type: 'success',
              message: '成功'
            })
          } else {
            that.$message.error(res.result.isSuccess)
          }
        })
      } else {
        that.$message.error(that.errorMessage)
      }
    },
    submitAreaPaper(index) {
      console.log(index)
      this.req.riskRange = this.paperAreas[index].riskCode
      this.req.manageCom = this.paperAreas[index].manageCom
      this.req.paperType = this.paperAreas[index].manageCom
      this.req.questionCount = this.paperAreas[index].questionCount
      this.req.riskCount = this.paperAreas[index].questionCount
      let that = this
      let repeat = false
      for (let key in this.tempPapers) {
        if (this.paperAreas[index].manageCom == this.tempPapers[key].manageCom && index != key) {
          repeat = true
        }
      }
      // if (!repeat) {
        // console.log(this.req)
        api.post(url.saveExamPaper, this.req, function(res) {
          if (res.result.isSuccess === true) {
            that.$message({
              type: 'success',
              message: '成功'
            })
            that.init()
          } else {
            if (res.result.errorCode == 'E002') {
              that.$message.error(res.result.errors[0].error)
            } else {
              that.$message.error(res.result.error)
            }
          }
        })
      // } else {
      //   that.$message.error('当前地区已存在试题')
      // }
    },
    initManageCom() {
      let that = this
      api.post(url.initManageCom, {}, function(res) {
        that.ManageComOptions = res.data
      })
    },
    init() {
      let that = this
      api.post(url.initExamPaperType, {}, function(res) {
        that.show = res.data.paperTypeNew
        that.paperAreas = res.data.paperTypeAreas
        that.tempPapers = res.data.paperTypeAreas
        that.riskCode = res.data.paperTypeNewRisk.riskRange
        // console.log(that.riskCode,'riskCode')
        that.questionNumber = res.data.paperTypeNewRisk.riskCount
        window.sessionStorage.setItem('questionNumber',that.questionNumber)
      })
      api.post(url.initQuestionNum, {}, function(res) {
        that.initQuestionCount = res.data
      })
    },
    addAreaPaper() {
      this.paperAreas.push({ isTemp: true })
    },
    deleteAreaPaper(index) {
      let req = {
        paperType: this.paperAreas[index].manageCom
      }
      let that = this
      if (!this.paperAreas[index].isTemp) {
        api.post(url.deleteExamPaper, req, function(res) {
          if (res.result.isSuccess === true) {
            that.$message({
              type: 'success',
              message: '成功'
            })
            that.init()
          } else {
            if (res.result.errorCode == 'E002') {
              that.$message.error(res.result.errors[0].error)
            } else {
              that.$message.error(res.result.error)
            }
          }
        })
      } else {
        let papers = []
        for (var key in this.paperAreas) {
          if (index != key) {
            papers.push(this.paperAreas[key])
          }
        }
        this.paperAreas = papers
      }
    }
  },
  created(){
    // if(window.sessionStorage.getItem('questionNumber')&&window.sessionStorage.getItem('riskCollect')){
    //   let that = this
    //   let params = {
    //     riskRange:window.sessionStorage.getItem('riskCollect'),
    //     riskCount:window.sessionStorage.getItem('questionNumber')
    //   }
    //   api.post(url.calculateQuestionCount,params, function(res) {
    //     if (res.result.isSuccess) {
    //         that.subjectNum = res.data
    //         window.sessionStorage.removeItem('questionNumber')
    //         window.sessionStorage.removeItem('riskCollect')
    //     } else {
    //       that.$message({

    //       });
    //     }
    //   });
    // }
  },
  mounted() {
    this.initManageCom()
    this.init()
    this.initRiskTypes();
    this.initInternetPaper()
    let that = this
    setTimeout(function(){
      if(window.sessionStorage.getItem('questionNumber')&&window.sessionStorage.getItem('riskCollect')){
        // let that = this
        let params = {
          riskRange:window.sessionStorage.getItem('riskCollect'),
          riskCount:window.sessionStorage.getItem('questionNumber')
        }
        api.post(url.calculateQuestionCount,params, function(res) {
          if (res.result.isSuccess) {
              that.subjectNum = res.data
              // window.sessionStorage.removeItem('questionNumber')
              // window.sessionStorage.removeItem('riskCollect')
          } else {
            this.$message({

            });
          }
        });
      }
    },500)
    // that.$nextTick(function(){
    //   if(window.sessionStorage.getItem('questionNumber')&&window.sessionStorage.getItem('riskCollect')){
    //     let that = this
    //     let params = {
    //       riskRange:window.sessionStorage.getItem('riskCollect'),
    //       riskCount:window.sessionStorage.getItem('questionNumber')
    //     }
    //     api.post(url.calculateQuestionCount,params, function(res) {
    //       if (res.result.isSuccess) {
    //           that.subjectNum = res.data
    //           window.sessionStorage.removeItem('questionNumber')
    //           window.sessionStorage.removeItem('riskCollect')
    //       } else {
    //         that.$message({

    //         });
    //       }
    //     });
    //   }
    // });
  },
  destroyed(){
    window.sessionStorage.removeItem('questionNumber')
    window.sessionStorage.removeItem('riskCollect')
  },
  watch:{
    questionNumber(){
      if(this.questionNumber.length){
        let that = this
        let params = {
          riskRange:this.riskCollect,
          riskCount:this.questionNumber
        }
        api.post(url.calculateQuestionCount,params, function(res) {
          if (res.result.isSuccess) {
              that.subjectNum = res.data
          } else {
            that.$message({

            });
          }
        });
      }
    }
  }
}
</script>

<style scoped>
#new .el-select:after {
  content: '新人产品试卷默认选中所有险种禁止修改';
  position: absolute;
  width: 100%;
  left: 0;
}
#new .el-button {
  float: right;
  margin-right: 15px;
}

.el-input__inner {
  padding: 0;
  text-align: center;
}
.el-col-24 {
  text-align: left;
  margin-left: 14.7%;
}
.main {
  width: 100%;
  height: 80vh;
  padding: 0px 0 20px 0;
}
.paperItem {
  width: 95%;
  height: auto;
  margin: 20px auto;

  background: white;
  font-size: 12px;
  text-align: center;
}
.title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  font-size: 16px;
  text-align: left;
  background: #e0e0e0;
}
.row {
  margin-bottom: 10px;
  line-height: 40px;
}
.rowChild {
  margin-left: 10px;
}
.paperItemMain,
.areapaperItemMain {
  padding: 40px 0 0px 0;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
.areapaperItemMain:not(:first-child) {
  /* margin-top: 20px; */
  border-top: 1px solid #e0e0e0;
}
.input {
  width: 40%;
}
.add_btn {
  float: right;
  margin-top: 5px;
  margin-right: 20px;
}
.separate {
  width: 80%;
  margin-left: 14%;
  margin-bottom: 10px;
  border: 1px solid rgb(224, 224, 224);
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examManage/paperConfig.vue